// @flow
import React from 'react';
import { connect } from 'formik';
type PropsType = {
  formik: any
};
class ErrorFocus extends React.Component<PropsType> {
  componentDidUpdate(prevProps) {
    const { isSubmitting, isValidating, errors } = prevProps.formik;
    const keys = Object.keys(errors);
    if (keys.length > 0 && isSubmitting && !isValidating) {
      const errorElement = document.querySelector(`[name="${keys[0]}"]`);
      if(errorElement) { errorElement.focus(); }
    }
  }

  render() {
    return null;
  }
}

export default connect(ErrorFocus);
